import {
    GET_ALL_PRODUCT_RECEIPT_IMPORT,
    CREATE_NEW_PRODUCT_RECEIPT_IMPORT,
    UPDATE_SPECIFIC_PRODUCT_RECEIPT_IMPORT,
    GET_SPECIFIC_PRODUCT_RECEIPT_IMPORT,
    REMOVE_PRODUCT_RECEIPT_IMPORT
} from '@/redux/actions/types'

const INIT_STATE = {
    product_receipt_import_list: [],
    current_product_receipt_import: {},
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALL_PRODUCT_RECEIPT_IMPORT: {
            return {
                ...state,
                product_receipt_import_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page)
                }
            }
        }
        case CREATE_NEW_PRODUCT_RECEIPT_IMPORT: {
            return {
                ...state,
                product_receipt_import_list: [
                    action.payload,
                    ...state.product_receipt_import_list
                ],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_PRODUCT_RECEIPT_IMPORT: {
            return { ...state, current_product_receipt_import: action.payload }
        }
        case GET_SPECIFIC_PRODUCT_RECEIPT_IMPORT: {
            let index = state.product_receipt_import_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.product_receipt_import_list];
            temp[index] = action.payload;
            return { ...state, product_receipt_import_list: temp }
        }
        case REMOVE_PRODUCT_RECEIPT_IMPORT: {
            let temp = state.product_receipt_import_list.filter(role => {
                return action.payload.indexOf(role.id) < 0;
            });
            return { ...state, product_receipt_import_list: temp }
        }
        default:
            return { ...state }
    }

}
